import { QueryClient } from "react-query";
import { RouteObject } from "react-router";
import { SERVER_SETTINGS_SUBPATH } from "./const";
import ServerSettings from "./ServerSettings";

export default (queryClient: QueryClient): RouteObject => ({
  path: SERVER_SETTINGS_SUBPATH,
  element: <ServerSettings />,
});
